module.exports = __webpack_public_path__ + "img/coin.9538cfab.svg";